import * as brokers from './backend/brokers';
import * as publicApis from './backend/public';
import * as users from './backend/users';
import * as brokerAssistants from './backend/broker-assistants';
import * as crm from './backend/crm';

export default {
  brokers,
  brokerAssistants,
  crm,
  public: publicApis,
  users,
};
